import React from 'react';
import { Box, Typography, IconButton, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Logo from '../../utilities/dummy_assets/MBF_Logo.png';
import mapITlogo from '../../utilities/dummy_assets/mapITlogo.png';
import background from '../../utilities/dummy_assets/background.png';
import tinkerersLogo from '../../utilities/dummy_assets/tinkerersLogo.png';
import mapitLoginLogo from '../../utilities/dummy_assets/mapitLoginLogo.png';
import { useState } from 'react';
import Logos from '../../components/logos';

const typographyStyle = {
  width: '100%',
  color: 'var(--Primary-Primary01, #007BFF)',
  padding: '10px 14px',
  textAlign: 'center',
  fontFamily: 'Inter',
  fontSize: '1.25rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: '-0.01375rem',
  borderRadius: '0.75rem',
  border: '1px solid var(--Accent-Accent-00, #007BFF)',
};
const boxStyle = {
  height: '48px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  alignSelf: 'stretch',
  cursor: 'pointer',
  width: '100%',
};

const CommonLoginPage = () => {
  const navigate = useNavigate();

  // TODO: reuse functionality
  // const handleAdminLoginClick = (adminName) => {
  //     console.log(adminName);
  //     navigate('/adminlogin', { state: { adminName } });
  //   };
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        flexGrow: 1,
        backgroundColor: { xs: 'white', sm: '#F7F7F7' },
        backgroundImage: { xs: 'none', sm: `url(${background})` },
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* <Box
                sx={{
                    position: "absolute",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-end",
                    top: '12px',
                    left: "50px",
                    p: '16px 24px'
                }}
            >
                <img src={Logo} alt="MBF Logo" style={{ height: '69px', width: '159px' }} />
            </Box> */}

      {/* "Go to User Site" link */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          p: '16px 32px',
        }}
      >
        <span
          onClick={() =>
            (window.location.href = 'https://tinkerspace.mis.mapit.ai/login')
          }
          style={{
            color: 'var(--Accent-Accent-01, #0062CC)',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
        >
          Go to Student Site
        </span>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'center', // Center content vertically
          alignItems: 'center', // Center content horizontally
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '1.5rem',
            backgroundColor: 'white',
            width: { xs: '90%', sm: '30%' },
            padding: '1rem',
            borderRadius: '16px',
            boxShadow: { xs: 'none', sm: '0 4px 6px rgba(0, 0, 0, 0.1)' },
          }}
        >
          <Box sx={{ alignSelf: 'center' }}>
            <Typography
              sx={{
                mb: '0.5rem',
                color: 'var(--Primary-Primary01, #212121)',
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '24px',
                fontStyle: 'normal',
                fontWeight: 600,
                lineHeight: 'normal',
                letterSpacing: ' -0.02475rem',
                alignSelf: 'center',
              }}
            >
              Sign In
            </Typography>
            <Typography
              sx={{
                color: 'var(--Primary-Primary01, #898989)',
                fontFamily: 'Inter',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
                letterSpacing: ' -0.02475rem',
                alignSelf: 'center',
              }}
            >
              to your MIS account
            </Typography>
          </Box>
          <Box sx={boxStyle} onClick={() => navigate('/mbf-admin-login')}>
            <Typography sx={typographyStyle}>Login as MBF Admin</Typography>
          </Box>
          <Box sx={boxStyle} onClick={() => navigate('/adminlogin')}>
            <Typography sx={typographyStyle}>Login as Admin</Typography>
          </Box>
          <Typography
            sx={{
              color: 'var(--Primary-Primary01, #3F3F3F)',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: { xs: '16px', sm: '20px' },
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 'normal',
              letterSpacing: '-0.01375rem',
              margin: 'auto',
              marginTop: '0px',
            }}
          >
            Don’t have an account?{' '}
            <span
              onClick={() => navigate('/register-instructions')}
              style={{
                color: 'var(--Accent-Accent-01, #007BFF)',
                cursor: 'pointer',
              }}
            >
              Register here
            </span>
          </Typography>
          <Box
            sx={{
              alignSelf: 'center',
              display: 'flex',
              gap: '1rem',
              marginTop: '1rem',
            }}
          >
            {/* LinkedIn */}
            <Link
              href="https://www.linkedin.com/company/maker-bhavan-foundation/"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#0077B5', '&:hover': { opacity: 0.8 } }}
            >
              <IconButton sx={{ padding: '4px' }}>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="#0077B5">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </IconButton>
            </Link>

            {/* YouTube */}
            <Link
              href="https://www.youtube.com/@Makerbhavanfoundation"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#FF0000', '&:hover': { opacity: 0.8 } }}
            >
              <IconButton sx={{ padding: '4px' }}>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="red">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                </svg>
              </IconButton>
            </Link>

            {/* Instagram */}
            <Link
              href="https://www.instagram.com/makerbhavan_india/?igsh=dWRhN3djbzM5cnNi"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: '#E4405F', '&:hover': { opacity: 0.8 } }}
            >
              <IconButton sx={{ padding: '4px' }}>
                <svg width="30" height="30" viewBox="0 0 24 24" fill="#E4405F">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                </svg>
              </IconButton>
            </Link>
          </Box>
        </Box>
      </Box>

      {/* Footer with "Powered by" */}
      <Logos />
    </Box>
  );
};
export default CommonLoginPage;
